module.exports = __webpack_public_path__ + "static/media/video-virtual-showroom.ed3d40bc.mp4";